module.exports = __webpack_public_path__ + "img/16.43dba6fc.png";